module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_3-8991462960c9c1739134b808153fba1a.jpg";